import ReactDOM from 'react-dom';
import './index.css';
import './reset.css';
import { makeMainRoutes } from './routes';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const routes = makeMainRoutes();

ReactDOM.render(
    routes, document.getElementById('root')
);
